import { render, staticRenderFns } from "./UpdateLessonCategoryDialog.vue?vue&type=template&id=ce85ef18"
import script from "./UpdateLessonCategoryDialog.vue?vue&type=script&lang=js"
export * from "./UpdateLessonCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports